import {
  SIGNUP_STEPS_DIRECT_UK,
  SIGNUP_STEPS_DIRECT_UK_VARIANT,
  SIGNUP_STEPS_PARTNER_UK,
  SIGNUP_STEPS_PARTNER_UK_VARIANT,
} from '../constants';
import { TSignupStepsUK } from '../types';

const getSignupSteps = (isDirectCustomer: boolean, variant: boolean) => {
  if (isDirectCustomer) {
    return variant ? SIGNUP_STEPS_DIRECT_UK_VARIANT : SIGNUP_STEPS_DIRECT_UK;
  }

  return variant ? SIGNUP_STEPS_PARTNER_UK_VARIANT : SIGNUP_STEPS_PARTNER_UK;
};

/**
 * Calculate the furthest step id based on the current max_reached_step id and updated route.
 */
export const getMaxReachedStep = (
  currentFurthestStep: TSignupStepsUK,
  updatedFurthestStep: TSignupStepsUK,
  isDirectCustomer: boolean = false,
  variant: boolean = false,
) => {
  const signupSteps = getSignupSteps(isDirectCustomer, variant);

  const nextStepIndex = signupSteps.findIndex(
    (step) => step === updatedFurthestStep,
  );

  const furthestStepIndex = signupSteps.findIndex(
    (step) => step === currentFurthestStep,
  );

  if (nextStepIndex <= furthestStepIndex) return currentFurthestStep;

  return updatedFurthestStep;
};
